export { default } from './EditorialTaxonomy';
